const namespace = 'Administration';

export const RECEIVE_USERSPACE_USERS_SUCCESS = `${namespace}/RECEIVE_USERSPACE_USERS_SUCCESS`;
